import { render, staticRenderFns } from "./AlertMessage1.vue?vue&type=template&id=6399a4c1&scoped=true&"
import script from "./AlertMessage1.vue?vue&type=script&lang=js&"
export * from "./AlertMessage1.vue?vue&type=script&lang=js&"
import style0 from "./AlertMessage1.vue?vue&type=style&index=0&id=6399a4c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6399a4c1",
  null
  
)

export default component.exports